module.exports = __webpack_public_path__ + "media/images/sales/early/heading-apply-90a9ecfe6af81a2dd23db51431288883.svg";